/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

const RECENT_PROJECT = 'recent-project';
const RECENT_ORGANIZATION = 'recent-org';

export function getRecentProject() {
  return localStorage.getItem(RECENT_PROJECT) || '';
}

export function setRecentProject(projectID: string) {
  localStorage.setItem(RECENT_PROJECT, projectID);
}

export function getRecentOrganization() {
  return localStorage.getItem(RECENT_ORGANIZATION) || '';
}

export function setRecentOrganization(organization: string) {
  localStorage.setItem(RECENT_ORGANIZATION, organization);
}
